import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=2451a84c"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=2451a84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports